import { gql, type TypedDocumentNode } from "@apollo/client";
import type { ApplicationStage, ApplicationType } from "@/pages/people/membership-services/applications/types";

export const GET_NON_ACTIVE_CLASSIFICATIONS_QUERY = gql`
  query GetNonActiveClassifications {
    classifications {
      nodes {
        id
        name
        description
      }
    }
  }
`;

export const GET_SECTIONS_QUERY = gql`
  query GetSections($input: BackofficeCRMSectionsInput!) {
    crmSections(input: $input) {
      nodes {
        id
        name
        legacyId
      }
    }
  }
`;

export type NonActiveClassificationsQueryResponse = {
  classifications: {
    nodes: Array<{
      id: string;
      name: string;
      description?: string | null;
    }>;
  };
};

export type SectionsQueryResponse = {
  crmSections: {
    nodes: Array<{
      id: string;
      name: string;
      legacyId?: string | null;
    }>;
  };
};

export type PersonMembershipApplication = {
  id: string;
  applicationType: ApplicationType;
  status: ApplicationStage;
  submittedAt: string | null;
  reviewer: {
    id: string;
    name: string;
  } | null;
  person: {
    primarySection: {
      id: string;
      name: string;
    } | null;
  };
};

export type PersonApplicationHistoryQueryData = {
  person: {
    id: string;
    membershipApplications: PersonMembershipApplication[];
  };
};

export type PersonApplicationHistoryQueryVariables = { pgaId: string };

export const GET_PERSON_APPLICATION_HISTORY_QUERY: TypedDocumentNode<
  PersonApplicationHistoryQueryData,
  PersonApplicationHistoryQueryVariables
> = gql`
  query GetPersonApplicationHistory($pgaId: ID!) {
    person(pgaId: $pgaId) {
      id
      membershipApplications {
        id
        applicationType
        status
        submittedAt
        reviewer {
          id
          name
        }
        person {
          primarySection {
            id
            name
          }
        }
      }
    }
  }
`;
